// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dfdb0d71","455":"b06868b9","762":"ce4d2fa2","857":"0e34911a","977":"2caed02d"}[chunkId] + ".chunk.js";
};